import type { SizeBucket } from "./types";

const MB = 1024 * 1024;

/** Coarse file size class, so events never carry an exact size. */
export function sizeBucket(bytes: number): SizeBucket {
  if (bytes < MB) return "under_1mb";
  if (bytes < 10 * MB) return "1_10mb";
  return bytes < 100 * MB ? "10_100mb" : "over_100mb";
}
